/**
 * html attribute：
 * data-dialog-id optional, use to find dialog element by same attribute.
 * 
 * @event custom-dialog:open
 */
if (!customElements.get("custom-dialog-trigger")) {
  class CustomDialogTrigger extends HTMLElement {
    constructor() {
      super();
      this.dialogId = this.getAttribute('data-dialog-id');
    }

    connectedCallback() {
      this.addEventListener('click', () => {
        let dialog;
        if (this.dialogId != null) {
          // data-dialog-id element
          dialog = document.querySelector(`custom-dialog[data-dialog-id="${this.dialogId}"]`);
        } else {
          dialog = this.nextElementSibling;
        }
        this.dispatchEvent(new CustomEvent("custom-dialog:open", {
          detail: {
            el: dialog,
          }, bubbles: true
        }));
        console.log(dialog)
        if (dialog && dialog.tagName === 'CUSTOM-DIALOG') {
          dialog.setAttribute('open', '');
          const productInfoContainer = dialog.closest('.product__info-wrapper');
          if (productInfoContainer) {
            productInfoContainer.style.zIndex = '999';
          }
          // document.body.style.overflow = 'hidden';
        }
      });
    }
  }
  customElements.define('custom-dialog-trigger', CustomDialogTrigger);
}

if (!customElements.get("custom-dialog")) {
  /**
   * @event custom-dialog:close
   */
  class CustomDialog extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const closeButton = this.querySelector('.drawer-close-overlay, .custom-dialog__close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.removeAttribute('open');
          const productInfoContainer = this.closest('.product__info-wrapper');
          if (productInfoContainer) {
            productInfoContainer.style.zIndex = '';
          }
          // document.body.style.overflow = '';
          this.dispatchEvent(new CustomEvent("custom-dialog:close", {
            detail: {
              el: this,
            },
            bubbles: true,
          }));
        });
      }
    }
  }
  customElements.define('custom-dialog', CustomDialog);
}